/**
 * Здесь собраны все доступные провайдеры ролей
 */

import {Provider as ProviderName} from './index'


interface IProvider {
  fetchRoles (): Promise<string[]>
  getIDMRoleUrl (): string
}

export type Providers = {[k in ProviderName]: IProvider}

export function createProviders (/* api */): Providers {
  /**
   * Провайдер ролей CTT админки
   */
  class CTTProvider implements IProvider {
    /**
     * Загрузить доступные роли
     */
    async fetchRoles (): Promise<string[]> {
      return []
    }
    /**
     * Запросить роль
     */
    getIDMRoleUrl () {
      const userName = ''

      return `https://idm.yandex-team.ru/#rf-role=pO1squlT#${userName}@cttadmin/ctt/ROLE_SUPERVISOR;;;,rf-expanded=pO1squlT,rf=1`
    }
  }

  return {
    ctt: new CTTProvider()
  }
}

